import React from "react";
import styled from "styled-components";

import { WIDTHS } from "./SelectWidth";

const Container = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 8px auto;
`;

const CoolTool = styled.div`
  height: 24px;
  width: 60px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  padding: 4px;

  :hover {
    border: 1px solid;
    border-color: ${props => props.active ? "#aaa" : "#666"};
  }
`;
const CoolToolMool = styled.div`
 width: 100%;
 height: ${props => props.width}px;
 background-color: ${props => props.color};
 margin: auto;
 border-radius: 5px;
`;

const ThicknessGrid = (props) => (
  <Container>
    {WIDTHS.map((width, index) =>
      <CoolTool
        key={index}
        onClick={() => props.onChange(width)}
        active={props.value === width}
      >
        <CoolToolMool
          color={props.value === width ? props.color : "grey"}
          width={width}
        />
      </CoolTool>
    )}
  </Container>
);

export default ThicknessGrid;


// WEBPACK FOOTER //
// ./src/components/Popup/ThicknessGrid.js